"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSteps = exports.createColoursArray = exports.rgbaColor = void 0;
var rgbaColor = function (values) {
    var r = values.r, g = values.g, b = values.b, a = values.a;
    if (r > 255 || g > 255 || b > 255 || r < 0 || g < 0 || b < 0) {
        throw new Error("rgb values must be between 0 and 255");
    }
    if (a > 1 || a < 0) {
        throw new Error("Alpha value must be between 0 and 1");
    }
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
};
exports.rgbaColor = rgbaColor;
var createColoursArray = function (start, end, steps) {
    var s_r = start.r;
    var s_g = start.g;
    var s_b = start.b;
    var s_a = start.a;
    var e_r = end.r;
    var e_g = end.g;
    var e_b = end.b;
    var e_a = end.a;
    var returnArray = [];
    var _rstep = calculateSteps(s_r, e_r, steps);
    var _gstep = calculateSteps(s_g, e_g, steps);
    var _bstep = calculateSteps(s_b, e_b, steps);
    var _astep = calculateSteps(s_a, e_a, steps);
    for (var i = 0; i < steps; i++) {
        s_r = Math.round(start.r + _rstep + (_rstep * i));
        s_g = Math.round(start.g + _gstep + (_gstep * i));
        s_b = Math.round(start.b + _bstep + (_bstep * i));
        s_a = start.a + _astep + (_astep * i);
        var o = { r: s_r, g: s_g, b: s_b, a: s_a, rgba: "rgba(".concat(s_r, ",").concat(s_g, ",").concat(s_b, ",").concat(s_a.toFixed(3), ")") };
        returnArray.push(o);
    }
    return returnArray;
};
exports.createColoursArray = createColoursArray;
var calculateSteps = function (start, end, steps) {
    return (end - start) / steps;
};
exports.calculateSteps = calculateSteps;
